import { Component, Mixins, Prop } from 'vue-property-decorator'
import MixinInterface from '@/_mixins/index'

@Component({
    mixins: [],
})
export default class Container extends Mixins<MixinInterface>() {
    @Prop({ default: false }) loaded!: boolean
    @Prop({ default: false }) accessible!: boolean
    @Prop({ default: null }) error!: string
    @Prop({ default: null }) viewn!: string
}
